module.exports = __webpack_public_path__ + "static/media/back.fff8cdb0.png";